<script>
    import Dropdown from './ui/Dropdown';

    export default {
        props: {
            actions: {
                required: true,
                type: Object
            },
            ariaLabel: {
                type: String,
                default: 'Actions'
            },
            iconClass: {
                type: String,
                default: 'bi bi-three-dots'
            },
            isLoading: Boolean,
            menuClass: String,
            strategy: String
        },
        components: {
            Dropdown
        },
        computed: {
            getActions() {
                let actions = [];
                for (let key in this.actions) {
                    if (Object.prototype.hasOwnProperty.call(this.actions, key) && this.actions[key] !== false)
                        actions.push({
                            text: key,
                            click: this.actions[key]
                        });
                }

                return actions;
            },
            hasSomeAction() {
                return this.getActions.length > 0 || !!this.$slots.default;
            }
        },
        methods: {
            onItemClick(action, e) {
                e?.stopPropagation();
                this.$refs.dropdown?.hide();

                typeof action === 'function' && action();
            }
        }
    };
</script>

<template>
    <div v-if="hasSomeAction" class="actions-dropdown">
        <span v-if="isLoading > 0" class="btn btn-sm text-dark">
            <span class="spinner-border spinner-border-sm" role="status"></span>
        </span>
        <Dropdown
            :aria-label="ariaLabel"
            v-else
            ref="dropdown"
            no-caret
            :options="getActions"
            buttonClass="btn-outline-light rounded-1 border-0 fs-4"
            :menuClass="menuClass"
            :strategy="strategy"
            placement="bottom-start"
            @buttonClick="e => e.stopImmediatePropagation()"
            @itemClick="(op, e) => onItemClick(null, e)"
        >
            <template #button>
                <i :class="iconClass"></i>
            </template>
            <slot />
        </Dropdown>
    </div>
</template>

<style lang="scss">
    .actions-dropdown {
        line-height: 1;
        .gsb-dropdown {
            .gsb-dropdown-toggle {
                line-height: 1;
                padding: 0 !important;
                color: #555;
                height: 1.7rem;
                width: 2.1rem;

                &:after {
                    content: none;
                }

                &:hover {
                    background: #e3e3e1;
                }
            }
            .dropdown-menu {
                .dropdown-item {
                    padding: 0.75rem 1rem;
                }
            }
        }
    }
</style>
